import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import HeaderBreadCrumbs from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useGetFTPExportLogs, useResetFTPExport } from "./hooks/useFTP";

type Props = {};

const FTPExportLogs = (props: Props) => {
  
  const [filtersState,setFiltersState] = useState<any>({
    page:1,
    limit:10,
    search:'',
    sortColumn:'',
    monthYear:null
  })

    // APi
    const {mutate:resetFTPExport} = useResetFTPExport();
    const {data,isLoading,isSuccess} = useGetFTPExportLogs({enable:true,params:{
      page:filtersState.page,
      limit:filtersState.limit,
      search:filtersState.search,
      sortColumn:'',
      monthYear:filtersState.monthYear
    }})

    const FTPExportLogsData = !isLoading && isSuccess && data?.data?.ftpExportLogs?.map((item:any,index:number)=>(
      {
        sr :index + 1,
        date:item?.CreatedAt || '',
        filePath:item?.FilePath || '',
        totalrecords:item?.NoProcessedRecords || 0,
        StartTime:item?.StartTime || '',
        Processing:item?.ProcessingTime || '',
        EndTime: item?.EndTime || '',
        FtpExportLogId: item?.FtpExportLogId || null
      }
    ))

  // console.log('paginatipon',data?.data?.Pagination?.TotalRecords);

  const handleResetFTPExport = (row:any) => {
     const id: number = row.FtpExportLogId ?? null;
     if(id){
       resetFTPExport(id)
     }  
  };

  const handlePagination=(pageNo:any)=>{
          setFiltersState((prev:any)=>({
               ...prev,
               page:pageNo
          }))
  }
  const handleonChangeRowsPerPage=(limit:any,pageNo:any)=>{
      setFiltersState((prev:any)=>({
                   ...prev,
                   page:pageNo,
                   limit:limit
      }))
  }

  return (
    <div className="p-2">
      <HeaderBreadCrumbs
        title="FTP Export File Logs"
        buttons={[
          {
            label: "Export",
            onClick: () => alert("Action 2 clicked"),
            color: "#2e8dd3",
          },
        ]}
      />
      <BasicDataTable
        Title="FTP Export File Logs"
        data={!isLoading && isSuccess? FTPExportLogsData : []}
        columns={FtpExportColumn(handleResetFTPExport)}
        search={true}
        handleSearch={(e:any)=>setFiltersState((prev:any)=>({
              ...prev,
              search:e
        }))}
        onChangePage={(pageNo:number)=>{
          handlePagination(pageNo);
        }}
        paginationTotalRows={data?.data?.Pagination?.TotalRecords}
        
        onChangeRowsPerPage={(newPage:any,page:any)=>{
          handleonChangeRowsPerPage(newPage,page);
        }}
     />
    </div>
  );
};

export default FTPExportLogs;

const FtpExportColumn = (handleResetFTPExport: (row: any) => void) => [
  {
    name: "SR",
    selector: (row: { sr: string }) => row.sr,
    sortable: true,
    maxWidth:'100px'
  },
  {
    name: "Date",
    selector: (row: { date: string }) => row.date,
    sortable: true,
  },
  {
    name: "File Path",
    selector: (row: { filePath: string }) => row.filePath,
    sortable: true,
    wrap:true,
    width:'180px'
  },
  {
    name: "Total Records",
    selector: (row: { totalrecords: string }) => row.totalrecords,
    sortable: true,
    width:'150px'
  },
  {
    name: "Start Time",
    selector: (row: { StartTime: string }) => row.StartTime || '-',
    sortable: true,
    wrap:true,
    width:'150px'
  },
  {
    name: "End Time",
    selector: (row: { EndTime: string }) => row.EndTime ||'-',
    sortable: true,
    wrap:true,
    width:'150px'
  },
  {
    name: "Processing",
    selector: (row: { Processing: string }) => row.Processing ||'-',
    sortable: true,
    wrap:true,
    width:'150px'

  },
  {
    name: "Actions",
    cell: (row: any) => {
      const allValuesAreDash = Object.values(row).every(
        (value) => value === "-"
      );

      return allValuesAreDash ? (
        "-" 
      ) : (
        <button
          onClick={() => handleResetFTPExport(row)}
          className="btn btn-info"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
          //   disabled={disableCondition(row)}
        >
          Reset
        </button>
      );
    },
  },
];
 